import * as R from 'ramda'

// encodeQuery :: ({str: any}) -> str
export const encodeQuery = R.pipe(
  R.map(global.encodeURIComponent),
  R.toPairs,
  R.map(R.join('=')),
  R.join('&'),
  query => query && '?' + query,
)

// parseQuery :: (str) -> {str: str}
export const parseQuery = R.pipe(
  R.replace(/^\?/, ''),
  R.split('&'),
  R.filter(R.length),
  R.map(R.split('=')),
  R.fromPairs,
  R.map(global.decodeURIComponent),
)
